import React from "react";
import {
	Button,
	Card,
	CardBody,
	CardHeader,
	CardTitle,
	FormGroup,
	Input,
	Label
} from "reactstrap";
import moment from 'moment';
import { getInstanceLogsRequest, createLogRequest } from '../../api/log';

class History extends React.Component {

    constructor(props) {
		super(props);
		this.state = {
            component: null,
			logs: null,
			addingEntry: false,
			newEntryText: "",
			saving: false
		}
	}


    async componentDidMount() {
		const params = new URLSearchParams(this.props.location.search);
		const id = params.get('id');
        
		if (id) {
			const logs = await getInstanceLogsRequest(this.props.type, id);
            this.setState({ 
              logs
            })
		} else {
			this.goTo(`/${this.props.type}s`)
		}
	}

    toggleNewEntry = (value) => {
        this.setState({
          addingEntry: value,
          component: this.props.component
        });
    };

    goTo = path => this.props.history.push(path);

    saveLog = async () => {

		this.setState({ saving: true });
  
		const {
          component,
		  newEntryText
		} = this.state;
        
        let data = {};

        switch (this.props.type) {
            case 'client':
                data = {
                    client: component._id,
                    type: "Custom",
                    event: newEntryText,
                    is_admin: false
                  };
            break;
            case 'payment':
                data = {
                    payment: component._id,
                    type: "Custom",
                    event: newEntryText,
                    is_admin: false
                  };
            break;
            case 'seller':
                data = {
                    seller: component._id,
                    type: "Custom",
                    event: newEntryText,
                    is_admin: false
                  };
            break;
            case 'broker':
                data = {
                    broker: component._id,
                    type: "Custom",
                    event: newEntryText,
                    is_admin: false
                  };
            break;
            default:
                console.log("Some error in History type.")
        }

        console.log(data)


		await createLogRequest(data);
  
		const logs = await getInstanceLogsRequest(this.props.type, component._id);
  
		this.setState({ 
		  saving: false,
		  addingEntry: false,
		  logs
		});  
	}

    render () {

        const {
            logs,
            addingEntry,
            saving
        } = this.state;

        const {
            type
        } = this.props;

        return (
            <Card>
				<CardHeader className="mb-5">
                    <CardTitle tag="h3" style={{textTransform: "capitalize"}}>
                        {type} History
                    </CardTitle>
                    <Button 
                        className="float-right"
                        color="default"
                        onClick={() => this.toggleNewEntry(true)}
                    >
                        Add entry
                    </Button>
				</CardHeader>
				<CardBody>
				{addingEntry &&
					<>
					<FormGroup>
						<Label for="about">Enter details below</Label>
						<Input 
							type="textarea" 
							name="details" 
							id="details" 
							onChange={e => this.setState({newEntryText: e.target.value})}
						/>
					</FormGroup>
					<Button
						className="mt-3"
						color="danger"
						onClick={() => this.toggleNewEntry(false)}
						disabled={saving}
						size="md"
					>
						Cancel
					</Button>
					<Button
						className="mt-3"
						color="success"
						disabled={saving}
						onClick={() => this.saveLog()}
						size="md"
					>
						{!saving ? "Save" : "Saving..."}
					</Button>
					<hr />
					</>
				}
				{logs && logs.length
				? logs.map((log, i) => {
					return (
					<div className="typography-line" key={i}>
						<h4>
						<span>{moment(log.created_at).format("MM/DD/YYYY HH:mm:ss")}</span>
						{`${log.type} | ${log.event}`}
						</h4>
					</div>
					)
				})
				: <>
					This {type} doesn't have any entry on their history
					</>
				}
				</CardBody>
			</Card>
        )
    }

}

export default History;